import * as dTokens from 'ui-common/components/design-tokens';

// Define region-specific header configurations
const HEADER_CONFIGS = {
  US: {
    linkColor: '#FFFFFF',
    backgroundColor: dTokens.res_brand_color_006
  },
  AU: {
    linkColor: '#FFFFFF',
    backgroundColor: '#a72d7d'
  }
  // Add new regions here following the same structure
};

/**
 * Gets the header configuration for the current region
 * @returns {Object} The header configuration for the current region
 */
const getHeaderConfig = () => {
  const region = process.env.REACT_APP_BUILD_REGION;
  return HEADER_CONFIGS[region] || HEADER_CONFIGS.AU; // Default to AU if region not found
};

// Get the current region's header configuration
const currentHeaderConfig = getHeaderConfig();

// Export the header configuration values
export const defaultHeaderLinkColor = currentHeaderConfig.linkColor;
export const defaultHeaderBackgroundColor = currentHeaderConfig.backgroundColor;

// Export the full configuration object for more flexible usage
export const headerConfig = currentHeaderConfig;

// Export all region configurations for potential debugging or special use cases
export const allHeaderConfigs = HEADER_CONFIGS;
